import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { ReactFCC } from '@types';

import { useErrorContext } from '../../ErrorContext';

import { FatalError, IFatalErrorProps } from './components';
import { FatalErrorWrapper } from './styled';
import { getMessages, getPageOffSet } from './utils';

export const FatalErrorProvider: ReactFCC<IFatalErrorProps> = ({ children, errorCode }) => {
  const { pathname } = useLocation();

  const [translations, setTranslations] = useState<{ [key: string]: string }>({});

  const {
    settings: { locale },
  } = useApplicationBuildContext();

  const { fatalError } = useErrorContext();

  useEffect(() => {
    setTranslations(getMessages(locale));
  }, [locale]);

  return fatalError ? (
    <IntlProvider locale={locale} messages={translations}>
      <FatalErrorWrapper data-testid="fatal-error-wrapper" pageOffSetInRem={getPageOffSet(pathname)}>
        <FatalError data-testid="fatal-error" errorCode={errorCode} />
      </FatalErrorWrapper>
    </IntlProvider>
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  );
};
